export class S3ListPrefixesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subPrefixes",
            "baseName": "subPrefixes",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "sampleObjects",
            "baseName": "sampleObjects",
            "type": "Array<S3SampleObject>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3ListPrefixesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
